module.exports = __webpack_public_path__ + "static/media/1.bd34eb77.jpg";